import { useState } from 'react';
import './FAQ.css';

const faqs = [
  {
    q: 'How soon will I see results from ads and SEO?',
    a: 'Meta & Google ads start bringing enquiries within the first 1–2 weeks once campaigns go live. SEO is a longer game — expect steady ranking improvements in 3–6 months. We set realistic targets upfront so you always know what to expect and when.',
  },
  {
    q: 'Will my business come first on Google?',
    a: "No honest agency can guarantee the #1 spot — Google doesn't sell it. What we do guarantee is proper SEO groundwork, Google Business Profile optimisation, and ad campaigns that put you right in front of customers searching for your service in your area.",
  },
  {
    q: 'Can you grow my Instagram and Facebook followers?',
    a: 'Yes — but we focus on real followers who become customers, not bought numbers. We handle content creation, reels, posting calendar, and targeted promotions so your page grows with people who actually engage and enquire.',
  },
  {
    q: 'Who will provide the content and photos — me or you?',
    a: "Both work! If you have photos and videos, great — we'll polish and use them. If not, our team handles content writing, creatives, and can arrange shoots for your business. Either way, everything is approved by you before it goes live.",
  },
  {
    q: 'What about support after the website is launched?',
    a: "We don't disappear after launch. You get free support for initial fixes, and we offer affordable maintenance plans covering updates, backups, security, and small content changes — so your site always stays fresh and running.",
  },
  {
    q: 'How long will it take to build my website?',
    a: 'A standard business website goes live in 2–3 weeks. Bigger projects with e-commerce, custom features, or lots of content may take 4–6 weeks. We share a clear timeline before starting, so there are no surprises.',
  },
  {
    q: 'Do you take care of domain and hosting too?',
    a: "Yes, end-to-end. We register your domain, set up fast and secure hosting, connect your business email, and handle SSL — you don't need to deal with any technical setup yourself.",
  },
  {
    q: 'What kind of businesses do you work with?',
    a: 'All kinds — restaurants, retail shops, clinics, educational institutes, real estate, startups, and service businesses. Whatever your field, we tailor the website and marketing to how your customers actually search and buy.',
  },
  {
    q: 'Do you set up WhatsApp automation and Google Business Profile?',
    a: 'Yes! We set up WhatsApp Business with auto-replies and catalogs so you never miss an enquiry, and optimise your Google Business Profile so nearby customers find you first on Maps and Search.',
  },
  {
    q: 'Do you do branding — logo, posters, and creatives?',
    a: 'Yes. From logo design and brand colours to posters, brochures, packaging creatives, and festival post designs — we build a consistent look for your brand across print and digital.',
  },
  {
    q: 'Do you shoot videos and make reels for businesses?',
    a: 'Yes! Our team plans, shoots, and edits promo videos, product shoots, and trending reels for your brand. Video is the fastest-growing way to reach customers, and we handle it start to finish.',
  },
  {
    q: 'Which is better for my business — Meta ads or Google ads?',
    a: "It depends on your business. Google ads catch customers actively searching for your service; Meta (Facebook/Instagram) ads build awareness and reach people by interest and location. Often a mix of both works best — we'll recommend the right split for you.",
  },
  {
    q: 'What is AerialRoot Academy?',
    a: 'AerialRoot Academy is our training wing in Trichy where we teach practical digital marketing and web development — hands-on courses built from real client projects, ideal for students and business owners.',
  },
  {
    q: 'Do you work with clients outside Trichy?',
    a: 'Yes! Our office is in Thillai Nagar, Trichy, but we work with businesses across Tamil Nadu and beyond — Chennai, Madurai, Coimbatore and more. Meetings, approvals, and reporting all happen smoothly online.',
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="faq-section">
      <div className="faq-header reveal">
        <span className="section-label">FAQ</span>
        <h2 className="section-title">Frequently Asked <em>Questions</em></h2>
        <p className="section-sub">Real questions our clients ask us every week — answered straight.</p>
      </div>
      <div className="faq-list reveal stagger">
        {faqs.map((f, i) => (
          <div key={f.q} className={`faq-item ${open === i ? 'open' : ''}`}>
            <button
              className="faq-question"
              onClick={() => setOpen(open === i ? -1 : i)}
              aria-expanded={open === i}
            >
              <span>{f.q}</span>
              <svg className="faq-chevron" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>
            <div className="faq-answer">
              <p>{f.a}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
